var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('iframe',{attrs:{"src":_vm.iframeSrc,"width":"100%","height":"100%","frameborder":"0"},on:{"load":_vm.onIframeLoad}})])}
var staticRenderFns = []

export { render, staticRenderFns }